/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-dizzy-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm-4.375 9.006l-.881-.881 1.25-1.25-1.25-1.25.881-.881 1.25 1.25 1.25-1.25.881.881-1.25 1.25 1.25 1.25-.881.881-1.25-1.25-1.25 1.25zM10 15.625a1.875 1.875 0 110-3.75 1.875 1.875 0 010 3.75zm5.256-6.25l-.881.881-1.25-1.25-1.25 1.25-.881-.881 1.25-1.25-1.25-1.25.881-.881 1.25 1.25 1.25-1.25.881.881-1.25 1.25 1.25 1.25z"/>'
  }
})
